import _sfc_main from "./component-library175.mjs";
import "./component-library176.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "accordion-item", class: {
    "accordion-item--inactive-desktop": _vm.isOpenOnDesktop
  } }, [_c(_setup.LinkButton, { staticClass: "accordion-item__title", class: {
    "accordion-item__title--small": _vm.isSmall
  }, attrs: { "id": `accordionItemTitle${_setup.uid}`, "type": "button", "tag": "button", "no-styling": "", "aria-controls": `accordionItemPanel${_setup.uid}`, "aria-expanded": _setup.ariaIsOpen.toString(), "data-testid": "accordionItemTitle" }, on: { "click": _setup.toggleIsOpen, "keydown": _setup.handleKeydown } }, [_vm._t("title"), _c(_setup.Arrow, { staticClass: "accordion-item__icon", attrs: { "direction": _setup.isOpenDerived ? "top" : "bottom", "aria-hidden": "true", "tag": "span" } })], 2), _c(_setup.TransitionExpand, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.isOpenDerived, expression: "isOpenDerived" }], staticClass: "accordion-item__panel", attrs: { "id": `accordionItemPanel${_setup.uid}`, "aria-labelledby": `accordionItemTitle${_setup.uid}`, "aria-hidden": !_setup.ariaIsOpen, "role": "region", "data-testid": "accordionItemPanel" } }, [_c("div", { staticClass: "accordion-item__content", attrs: { "data-testid": "accordionItemContent" } }, [_vm._t("content")], 2)])])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "257595a3",
  null,
  null
);
const accordionItem = __component__.exports;
export {
  accordionItem as default
};
